import { Core } from './Core';

export class WindowService {
	core: Core;

	/**
	 * Constructor
	 * */
	constructor(core: Core) {
		this.core = core;
	}

	/**
	 * Called on resize of the window
	 * */
	resize = () => {
		this.core.sizes.width = window.innerWidth;
		this.core.sizes.height = window.innerHeight;

		// Update camera
		this.core.s('Camera').resizeEvent();

		// Update the renderer
		this.core.renderer.setSize(this.core.sizes.width, this.core.sizes.height);
		this.core.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
	};

	/**
	 * Sets up a listener for window resize
	 * */
	watchResize() {
		window.addEventListener('resize', this.resize.bind(this));
	}
}

export interface SizesInterface {
	width: number;
	height: number;
}
